/**
 * Lightweight wrapper around a plain object providing Map-like API
 * that components expect (cache.get(key), cache.has(key), etc.)
 * Replaces per-request LRU instantiation to reduce memory overhead.
 */
class SimpleCache {
  constructor(data = {}) {
    this._data = { ...data };
  }

  get(key) {
    return this._data[key];
  }

  set(key, value) {
    this._data[key] = value;
    return this;
  }

  has(key) {
    return key in this._data;
  }

  delete(key) {
    delete this._data[key];
  }

  // Backwards compat for components using .del() (lru-cache v6 API)
  del(key) {
    this.delete(key);
  }

  keys() {
    return Object.keys(this._data);
  }

  get size() {
    return Object.keys(this._data).length;
  }
}

export default SimpleCache;
